var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataDesc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52556 3.5C6.94937 3.5 7.16128 3.0625 6.85519 2.79167L3.8414 0.125C3.65304 -0.0416667 3.34696 -0.0416667 3.15859 0.125L0.144809 2.79167C-0.161279 3.0625 0.0506279 3.5 0.474441 3.5H6.52556Z",
    fill: "#B6C2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataDesc);
export default __webpack_public_path__ + "static/media/data-desc.88450dfe24db1224a9d88a579f5a4202.svg";
export { ForwardRef as ReactComponent };